// extracted by mini-css-extract-plugin
export default {"tooltipInfo":"Ei5ubL3jXA3OCM74asa0"};